export default __webpack_public_path__ + "static/media/Tick.c6f27cc8.svg";